type VersionInfo = {
  version: string;
  branch: string;
  pipeline: string;
  namespace: string;
};

// Capture the release of the HTML that loaded this app, once per page load.
// Fetching the latest metadata here could pair old HTML with a newer release.
const versionElement = document.getElementById('version-info');
if (!versionElement?.textContent) {
  throw new Error('Missing version-info in the page');
}

const versionInfo = JSON.parse(versionElement.textContent) as VersionInfo;
export default versionInfo;
